import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { detectLanguage } from '../../../utils/languageUtils';
import { motion } from 'framer-motion';
import { cn } from '../../../utils/cn';

interface ChatInputProps {
  onSend: (message: string) => void;
}

export function ChatInput({ onSend }: ChatInputProps) {
  const [input, setInput] = useState('');

  const handleSend = () => {
    if (!input.trim()) return;
    onSend(input);
    setInput('');
  };

  const getPlaceholder = () => {
    const language = detectLanguage(input);
    return language === 'nl' ? 'Type uw bericht...' : 'Type your message...';
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className="p-3 bg-[#f0f2f5] border-t"
    >
      <div className="flex items-center gap-2">
        <div className="flex-1 relative">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            placeholder={getPlaceholder()}
            className="w-full px-4 py-2.5 rounded-full bg-white border-none focus:outline-none focus:ring-2 focus:ring-brand-500 shadow-sm"
          />
        </div>
        
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={handleSend}
          className="bg-brand-500 text-white p-2.5 rounded-full hover:bg-brand-600 transition-colors shadow-sm"
          disabled={!input.trim()}
        >
          <Send size={20} />
        </motion.button>
      </div>
    </motion.div>
  );
}